import { authService } from './authService';

/**
 * Перехватчик запросов: сначала продлить токен Keycloak (если ему осталось < 70 с),
 * потом собрать заголовок авторизации.
 *
 * Вкладка, вернувшаяся из фона, иначе отправляла первые запросы (История, задачи,
 * квота) со старым токеном раньше, чем его продлит таймер, — ~1000 отказов
 * «Signature has expired» в день и «Не удалось загрузить» в Истории
 * (docs/CHANGELOG.md, 10.10.2026). Живой токен keycloak-js не продлевает,
 * одновременные продления сливает в одно — запросы от этого не тормозят.
 * `?.` — тесты подделывают authService без refreshSession.
 */
export async function withFreshAuth(config) {
  await authService.refreshSession?.();
  Object.assign(config.headers, authService.getAuthHeaders());
  return config;
}
